import { s } from "@kosmod/pancake"
import { TerrainCanvasID } from "./scene"
import { TerrainBrushID } from "./terrainBrush"
import { K3D } from "@kosmod/graphics-3d";

export type TerrainStrokeShape =
  | { type: 'box', box: K3D.Box2 }
  | { type: 'line', line: K3D.Line2 }

export const TerrainStrokeShape = s.ref<TerrainStrokeShape>()(s.du('type', {
  'box': { box: K3D.Box2 },
  'line': { line: K3D.Line2 },
}));

export type TerrainStroke = {
  brush: null | TerrainBrushID,
  canvas: TerrainCanvasID,
  layer: 'floor' | 'top-wall' | 'left-wall'
  shape: TerrainStrokeShape,
}
export const TerrainStroke = s.ref<TerrainStroke>()(s.o({
  brush: s.optional(TerrainBrushID),
  canvas: TerrainCanvasID,
  layer: s.lu(['floor', 'top-wall', 'left-wall']),
  shape: TerrainStrokeShape
}))
